var map = {
	"./article_listing.json": [
		87,
		0
	],
	"./enviroplus-setup.json": [
		89,
		4
	],
	"./git-file-mapper.json": [
		90,
		5
	],
	"./new-assignment.json": [
		91,
		6
	],
	"./octopus-energy.json": [
		92,
		7
	],
	"./pytest-filtering.json": [
		93,
		8
	],
	"./pytest-randomisation.json": [
		94,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 84;
module.exports = webpackAsyncContext;